import { Field } from "./field.model";
import { ActionOptionsArgs, SynchronisableAction } from "../../../core/store/actions/base-actions";
import { Action } from "@ngrx/store";

export const ENTITY = "field";
export const SUBMIT = "[Field] Submit";
export const REMOVE = "[Field] Remove";
export const SET_FILTER = "[Field] Set Filter";
export const BUMP_VERSION = "[Field] Bump Version";

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Field, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: Field, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class BumpVersionAction implements Action {
    readonly type = BUMP_VERSION;

    constructor(public payload: {jobId: string, fieldId: string}) {

    }
}

export type Actions
    = SubmitAction
    | RemoveAction
    | BumpVersionAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/field/field.actions.ts